var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"info-container-row",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"info-side-panel",attrs:{"cols":"11","md":"2"}},[_c('app-info-side-menu')],1),_c('v-col',{attrs:{"cols":"11","md":"7"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }